import RadioButtonGroup from 'components/RadioButton/RadioButtonGroup';

import { SelectFilterProps } from "./types"

export const SelectFilter = ({ items, selectedItems, onChange }: SelectFilterProps) => {
    return (
        <RadioButtonGroup
            className="flex flex-col gap-2 w-full p-5"
            value={selectedItems[0]}
            options={items}
            onValueChange={onChange}
            selectedColor="indigo-600"
        />
    )
}